import { getEntries, areEntriesLoaded } from '@/fleet-configuration/data-fleet/entries/entries-selectors'

export const getProjects = state => getEntries(state, 'entries.projects')

export const areProjectsLoaded = state => areEntriesLoaded(state, 'entries.projects')

export const getActiveProjectId = state => getProjects(state)[0]?.id
